import { render, staticRenderFns } from "./QuotationEditComponent.vue?vue&type=template&id=163f725c&scoped=true"
import script from "./QuotationEditComponent.vue?vue&type=script&lang=js"
export * from "./QuotationEditComponent.vue?vue&type=script&lang=js"
import style0 from "./QuotationEditComponent.vue?vue&type=style&index=0&id=163f725c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f725c",
  null
  
)

export default component.exports